import React, { useEffect } from 'react';
import Select from '../../../../components/form-elements/Select';
import { selectSubLocation } from '../../../../../modules/actions/standort/subLocation';
import CheckoutSublocation from '../CheckoutSublocation';
import { AddressHeader } from '../AddressDetailComponents/AddressHeader';
import { useDispatch, useSelector } from 'react-redux';
import { areaShopSubLocationsSelector } from '../../../../../modules/selectors/standort/markenStandort';
import {
    selectedCarBrandSelector,
    selectedSublocationCarBrandsSelector,
    selectedSublocationSelector,
    subLocationToCarBrands,
} from '../../../../../modules/selectors/standort/subLocation';
import { generateOptionsArray } from '../../../../../helpers/formHelper';

function findSubLocationById({ areaShopSubLocations, subLocationId }) {
    return areaShopSubLocations.find(subLocation => subLocation._id === subLocationId);
}

function SelectSublocation({ values, setFieldValue, handleBlur, touched, errors }) {
    const dispatch = useDispatch();
    const areaShopSubLocations = useSelector(areaShopSubLocationsSelector);
    const selectedSublocation = useSelector(selectedSublocationSelector);
    const globalSelectedCarBrand = useSelector(selectedCarBrandSelector);
    const selectedSublocationCarBrands = useSelector(selectedSublocationCarBrandsSelector);

    const isSingleBrandSubLocation = selectedSublocationCarBrands.length === 1;

    useEffect(() => {
        // Sync subLocation and selectedCarBrand into redux
        dispatch(
            selectSubLocation({
                subLocation: findSubLocationById({ areaShopSubLocations, subLocationId: values.selectedSublocation }),
                selectedCarBrand: values.selectedCarBrand,
            })
        );
    }, [areaShopSubLocations, dispatch, values.selectedCarBrand, values.selectedSublocation]);

    useEffect(() => {
        // Sync implied single brand from redux back into formik
        if (isSingleBrandSubLocation) {
            setFieldValue('selectedCarBrand', globalSelectedCarBrand);
        }
    }, [isSingleBrandSubLocation, globalSelectedCarBrand, setFieldValue]);

    return (
        <AddressHeader icon="fa-map-marker" title="Autohaus Auswahl" hideButton>
            <Select
                name="selectedSublocation"
                value={values.selectedSublocation}
                onChange={({ name, value }) => {
                    // Invalidate selectedCarBrand if selectedSublocation changes
                    setFieldValue('selectedCarBrand', '');
                    setFieldValue(name, value);
                }}
                onBlur={handleBlur}
                options={[
                    { label: 'Bitte wählen Sie einen Standort aus', value: '' },
                    ...areaShopSubLocations.map(subLocation => ({
                        label: `${subLocation.anschrift.strasse} • ${subLocation.anschrift.plz} ${
                            subLocation.anschrift.ort
                        } • ${subLocationToCarBrands(subLocation).join(', ')}`,
                        value: subLocation._id,
                    })),
                ]}
                error={touched.selectedSublocation && errors.selectedSublocation ? errors.selectedSublocation : undefined}
            />
            {selectedSublocation && !isSingleBrandSubLocation && (
                <Select
                    name="selectedCarBrand"
                    value={values.selectedCarBrand}
                    onChange={({ name, value }) => setFieldValue(name, value)}
                    onBlur={handleBlur}
                    options={generateOptionsArray({
                        additionalOption: { label: 'Bitte wählen Sie einen Marke aus', value: '' },
                        values: selectedSublocationCarBrands,
                    })}
                    error={touched.selectedCarBrand && errors.selectedCarBrand ? errors.selectedCarBrand : undefined}
                />
            )}
            {selectedSublocation && values.selectedCarBrand && (
                <CheckoutSublocation selectedSublocation={selectedSublocation} selectedCarBrand={values.selectedCarBrand} />
            )}
        </AddressHeader>
    );
}

export default SelectSublocation;
